import moment from "moment";
import ModalBasic from "../../../../pages/component/ModalBasic";
import { TextInput } from "../../../../components/allTypesInputComponents/AllTypeInputComponents";
import DatePicker from "../../../../components/datePicker/DatePicker";
import MultiSelectDropdown from "../../../dropdown/MultiSelectDropdown";
import ButtonLoader from "../../../common/buttonLoader/ButtonLoader";
import ValidationText from "../../../../utils/validation/ValidationText";

function AddEditProject(props) {
  const { isOngoing, isCompleted } = props;

  // const getFieldValue = (field) => {
  //     return props.editingProject?.[field] ?? props.newProject?.[field] ?? '';
  // };
  return (
    <ModalBasic
      id="show-add-edit-project-modal"
      modalOpen={props.modalOpen}
      setModalOpen={props.setModalOpen}
      title={
        props.editModel
          ? isOngoing
            ? "Edit Ongoing Project"
            : isCompleted
              ? "Edit Completed Project"
              : "Edit Project"
          : isOngoing
            ? "Add Ongoing Project"
            : isCompleted
              ? "Add Completed Project"
              : "Add Project"
      }
    >
      <div className="show-add-edit-project-modal-fields w-full flex justify-center items-center min-h-[200px]">
        <div className="bg-white p-6 rounded-lg model-overflow w-full max-w-6xl shadow-md">
          {/* <div className="flex justify-between items-center mb-4">
                        <h1 className="text-xl font-bold text-gray-800">
                            {props.editModel ? 'Edit Project' : 'Add Project'}
                        </h1>
                        <button onClick={props.closeModal} className="text-xl font-semibold leading-none">&times;</button>
                    </div> */}
          {/* Form Fields in Grid */}
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            {/* Contract No */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Contract No <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <TextInput
                  name="contractNo"
                  value={props.projectTrackRecordsDetails.contractNo}
                  identity="Prject_Tract_Records"
                  // value={getFieldValue('contractNo')}
                  handleChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  onBlur={() =>
                    props.validateField("contractNo", "Add_Project")
                  }
                  className="custom-input-popup"
                />
                <ValidationText
                  error={props.validStateProjectTrackRecord?.error?.contractNo}
                />
              </div>
            </div>

            {/* Project Title */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Project Title <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <textarea
                  name="projectTitle"
                  value={props.projectTrackRecordsDetails.projectTitle}
                  identity="Prject_Tract_Records"
                  onChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  onBlur={() =>
                    props.validateField("projectTitle", "Add_Project")
                  }
                  // value={getFieldValue('projectTitle')}
                  //handleChange={(e) => props.handleChange('projectTitle', "Prject_Tract_Records")}
                  className="custom-text-area-popup"
                />
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error?.projectTitle
                  }
                />
              </div>
            </div>

            {/* Project Type */}

            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 custom-label col-span-6">
                Project Type<span className="text-red-500">*</span>
              </label>
              <div className="w-full col-span-6 custop-popup">
                <MultiSelectDropdown
                  drpIdentity="SlotProjectType"
                  options={props.projectTypelist}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={props.handleChangeInDropdown}
                  allowSelectAll={false}
                  value={props.projectTypelist.filter(
                    (mainGroup) =>
                      mainGroup.value ===
                      props.projectTrackRecordsDetails.projectType
                  )}
                  disabled={props.isDisabledFlag}
                  className="w-full "
                  onBlur={() =>
                    props.validateField("projectTypeId", "Add_Project")
                  }
                />
                <ValidationText
                  error={props.validStateProjectTrackRecord?.error?.projectType}
                />
                {/* <ValidationText error={props.validStateProjectTrackRecord?.error?.projectTypeId} /> */}
              </div>
            </div>

            {/* Agency */}
            {props.projectTrackRecordsDetails.projectType === 2 && (
              <div className="grid grid-cols-12 w-100">
                <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                  Agency
                </label>
                <div className="col-span-6">
                  <TextInput
                    name="agency"
                    value={props.projectTrackRecordsDetails.agency}
                    identity="Prject_Tract_Records"
                    handleChange={(e) =>
                      props.handleChange(e, "Prject_Tract_Records")
                    }
                    className="custom-input-popup"
                    onBlur={() =>
                      props.validateField("projectLocation", "Add_Project")
                    }
                  />
                  <ValidationText
                    error={props.validStateProjectTrackRecord?.error?.agency}
                  />
                </div>
              </div>
            )}

            {/* Project Location */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Project Location <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                {/* <TextInput
                  name="projectLocation"
                  value={props.projectTrackRecordsDetails.projectLocation}
                  identity="Prject_Tract_Records"
                  handleChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  // value={getFieldValue('projectLocation')}
                  //handleChange={(e) => props.handleChange('projectLocation', "Prject_Tract_Records")}
                  className="custom-input-popup"
                  onBlur={() =>
                    props.validateField("projectLocation", "Add_Project")
                  }
                /> */}
                <textarea
                  name="projectLocation"
                  value={props.projectTrackRecordsDetails.projectLocation}
                  identity="Prject_Tract_Records"
                  onChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  // value={getFieldValue('projectLocation')}
                  //handleChange={(e) => props.handleChange('projectLocation', "Prject_Tract_Records")}
                  className="custom-text-area-popup"
                  onBlur={() =>
                    props.validateField("projectLocation", "Add_Project")
                  }
                ></textarea>
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error?.projectLocation
                  }
                />
              </div>
            </div>

            {/* Date of Commencement */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Date of Commencement <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <DatePicker
                  name="dateOfCommencement"
                  id="dateOfCommencement"
                  value={moment(
                    props.projectTrackRecordsDetails.dateOfCommencement
                  ).format("YYYY-MM-DD")}
                  identity="Prject_Tract_Records"
                  handleChange={(event) =>
                    props.handleChange(event, "Prject_Tract_Records")
                  }
                  onBlur={() =>
                    props.validateField("dateOfCommencement", "Add_Project")
                  }
                  className="col-span-6 custom-date-picker-popup"
                // value={getFieldValue('dateOfCommencement')}
                //handleChange={(e) => props.handleChange('dateOfCommencement', "Prject_Tract_Records")}
                />
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error
                      ?.dateOfCommencement
                  }
                />
              </div>
            </div>

            {/* Expected or Actual Completion */}
            {isOngoing && (
              <div className="grid grid-cols-12 w-100">
                <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                  Expected Date of Completion{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div className="col-span-6">
                  <DatePicker
                    name="dateofCompletion"
                    id="dateofCompletion"
                    value={moment(
                      props.projectTrackRecordsDetails.dateofCompletion
                    ).format("YYYY-MM-DD")}
                    identity="Prject_Tract_Records"
                    handleChange={(e) =>
                      props.handleChange(e, "Prject_Tract_Records")
                    }
                    onBlur={() =>
                      props.validateField("dateofCompletion", "Add_Project")
                    }
                    className="col-span-6 custom-date-picker-popup"
                  // value={getFieldValue('dateofCompletion')}
                  //handleChange={(e) => props.handleChange('dateofCompletion', "Prject_Tract_Records")}
                  />
                  <ValidationText
                    error={
                      props.validStateProjectTrackRecord?.error
                        ?.dateofCompletion
                    }
                  />
                </div>
              </div>
            )}

            {isCompleted && (
              <div className="grid grid-cols-12 w-100">
                <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                  Actual Date of Completion{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div className="col-span-6">
                  <DatePicker
                    name="actualDateOfCompletion"
                    value={moment(
                      props.projectTrackRecordsDetails.actualDateOfCompletion
                    ).format("YYYY-MM-DD")}
                    identity="Prject_Tract_Records"
                    handleChange={(e) =>
                      props.handleChange(e, "Prject_Tract_Records")
                    }
                    onBlur={() =>
                      props.validateField(
                        "actualDateOfCompletion",
                        "Add_Project"
                      )
                    }
                    className="col-span-6 custom-date-picker-popup"
                  // value={getFieldValue('actualDateOfCompletion')}
                  //handleChange={(e) => props.handleChange('actualDateOfCompletion', "Prject_Tract_Records")}
                  />
                  <ValidationText
                    error={
                      props.validStateProjectTrackRecord?.error
                        ?.actualDateOfCompletion
                    }
                  />
                </div>
              </div>
            )}

            {/* Award Value */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Award Value <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <TextInput
                  name="awardValue"
                  value={props.projectTrackRecordsDetails.awardValue}
                  identity="Prject_Tract_Records"
                  handleChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      props.handleChange(e, "Prject_Tract_Records");
                    }
                  }}
                  placeholder="Enter numeric value"

                  className="custom-input-popup col-span-6"
                  onBlur={() => props.validateField("awardValue", "Add_Project")}
                />
                <ValidationText
                  error={props.validStateProjectTrackRecord?.error?.awardValue}
                />
              </div>
            </div>

            {/* Main Contractor Name */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Main Contractor Name <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <TextInput
                  name="mainContractorName"
                  value={props.projectTrackRecordsDetails.mainContractorName}
                  identity="Prject_Tract_Records"
                  handleChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  // value={getFieldValue('mainContractorName')}
                  // handleChange={(e) => props.handleChange('mainContractorName', "Prject_Tract_Records")}
                  className="custom-input-popup"
                  onBlur={() =>
                    props.validateField("mainContractorName", "Add_Project")
                  }
                />
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error
                      ?.mainContractorName
                  }
                />
              </div>
            </div>

            {/* Main Contractor Telephone No. */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Main Contractor Telephone No.{" "}
                <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <TextInput
                  name="mainContractorTelephoneNo"
                  value={
                    props.projectTrackRecordsDetails.mainContractorTelephoneNo
                  }
                  identity="Prject_Tract_Records"
                  handleChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  // value={getFieldValue('mainContractorTelephoneNo')}
                  //handleChange={(e) => props.handleChange('mainContractorTelephoneNo', "Prject_Tract_Records")}
                  className="custom-input-popup"
                  onBlur={() =>
                    props.validateField(
                      "mainContractorTelephoneNo",
                      "Add_Project"
                    )
                  }
                />
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error
                      ?.mainContractorTelephoneNo
                  }
                />
              </div>
            </div>

            {/* Main Contractor Email */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Main Contractor Email <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <TextInput
                  name="mainContractorEmail"
                  value={props.projectTrackRecordsDetails.mainContractorEmail}
                  identity="Prject_Tract_Records"
                  handleChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  // value={getFieldValue('mainContractorEmail')}
                  //handleChange={(e) => props.handleChange('mainContractorEmail', "Prject_Tract_Records")}
                  className="custom-input-popup col-span-6"
                  onBlur={() =>
                    props.validateField("mainContractorEmail", "Add_Project")
                  }
                />
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error
                      ?.mainContractorEmail
                  }
                />
              </div>
            </div>

            {/* Contact Person Name */}
            <div className="grid grid-cols-12 w-100">
              <label className="block text-sm font-medium text-gray-700 mb-1 col-span-6 custom-label">
                Contact Person Name <span className="text-red-500">*</span>
              </label>
              <div className="col-span-6">
                <TextInput
                  name="contactPersonName"
                  value={props.projectTrackRecordsDetails.contactPersonName}
                  identity="Prject_Tract_Records"
                  handleChange={(e) =>
                    props.handleChange(e, "Prject_Tract_Records")
                  }
                  // value={getFieldValue('contactPersonName')}
                  // handleChange={(e) => props.handleChange('contactPersonName', "Prject_Tract_Records")}
                  className="custom-input-popup"
                  onBlur={() =>
                    props.validateField("contactPersonName", "Add_Project")
                  }
                />
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error?.contactPersonName
                  }
                />
              </div>
            </div>
          </div>
          {/* Upload */}
          <br />{" "}
          <label
            className="block text-sm font-medium text-gray-700 mb-1"
            htmlFor={`Upload_Project_Tract_Record`}
          >
            Supporting Documents <span className="text-red-500">*</span>
          </label>
          <div className="mt-6">
            <label
              className="block text-sm font-medium text-gray-700 mb-1"
              htmlFor="Letter_of_Award_or_Purchase"
            >
              Letter of Award and/or Purchase Order only
              <span className="text-red-500">*</span>{" "}
                  (You may upload up to 10 files)
            </label>

            {/* Hidden File Input */}
            <input
              type="file"
              id="Letter_of_Award_or_Purchase"
              multiple
              onChange={(event) =>
                props.onFileChange(event, "Letter_of_Award_or_Purchase")
              }
              className="hidden"
            />

            {/* Custom Orange Upload Button */}
            <label
              htmlFor="Letter_of_Award_or_Purchase"
              className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
            >
              Upload Files
            </label>

            {/* Uploaded Files List */}
            {props.letterofAwardorPurchaseOrderList?.length > 0 && (
              <div className="mt-5 space-y-2">
                {props.letterofAwardorPurchaseOrderList?.map((file, index) => {
                  let fileName = "Unnamed File";

                  if (typeof file === "string") {
                    fileName = file.split("/").pop() || "Unnamed File";
                  } else if (typeof file?.name === "string") {
                    fileName = file.name;
                  } else if (typeof file?.path === "string") {
                    fileName = file.path.split("/").pop() || "Unnamed File";
                  }

                  return (
                    <div
                      key={index}
                      className="file-uploaded-txt flex items-center text-sm text-black"
                    >
                      <img
                        src="/check-orange.png"
                        className="w-[25px] mr-3"
                        alt="Check Icon"
                      />
                      <span>{fileName}</span>

                      <button
                        className="underline text-[#e74c3c] font-[500] ml-3"
                        onClick={() =>
                          props.GetSlotsMemberFiles(
                            "Award_PurchaseOrder_Docs",
                            fileName
                          )
                        }
                      >
                        Download File
                      </button>

                      <button
                        className="underline text-[#e74c3c] font-[500] ml-3"
                        onClick={() =>
                          props.deleteFile(
                            fileName,
                            props.isCompleted
                              ? "Upload_letter_of_award_Completed"
                              : "Upload_letter_of_award_Ongoing"
                          )
                        }
                      >
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
            <ValidationText
              error={
                props.validStateProjectTrackRecord?.error
                  ?.LetterofAwardorPurchase
              }
            />
          </div>
          {props.isCompleted && (
              <div className="mt-6">
                <label
                  className="block text-sm font-medium text-gray-700 mb-1"
                  htmlFor="CertificateOfCompletionPath"
                >
                  Certificate of Completion{" "}
                  <span className="text-red-500">*</span>{" "}
                  (You may upload up to 10 files)
                </label>

                {/* Hidden File Input */}
                <input
                  type="file"
                  id="CertificateOfCompletionPath"
                  multiple
                  onChange={(event) =>
                    props.onFileChange(event, "CertificateOfCompletionPath")
                  }
                  className="hidden"
                //onBlur={() => props.validateField("certificateOfCompletionPath", "Add_Project")}
                />
                {/* Custom Orange Upload Button */}
                <label
                  htmlFor="CertificateOfCompletionPath"
                  className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
                >
                  Upload Files
                </label>

                {/* Uploaded Files List with Download/Delete */}
                {props.certificateofcompletionList?.length > 0 && (
                  <div className="mt-5 space-y-2">
                    {props.certificateofcompletionList.map((file, index) => {
                      let fileName = "Unnamed File";

                      if (typeof file === "string") {
                        fileName = file.split("/").pop() || "Unnamed File";
                      } else if (typeof file?.name === "string") {
                        fileName = file.name;
                      } else if (typeof file?.path === "string") {
                        fileName = file.path.split("/").pop() || "Unnamed File";
                      }

                      return (
                        <div
                          key={index}
                          className="file-uploaded-txt flex items-center text-sm text-black"
                        >
                          <img
                            src="/check-orange.png"
                            className="w-[25px] mr-3"
                            alt=""
                          />
                          <span>{fileName}</span>

                          <button
                            className="underline text-[#e74c3c] font-[500] ml-3"
                            onClick={() =>
                              props.GetSlotsMemberFiles(
                                "CertificateOfCompletion",
                                fileName
                              )
                            }
                          >
                            Download File
                          </button>

                          <button
                            className="underline text-[#e74c3c] font-[500] ml-3"
                            onClick={() =>
                              props.deleteFile(
                                fileName,
                                "Upload_certificate_of_completion"
                              )
                            }
                          >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
                <ValidationText
                  error={
                    props.validStateProjectTrackRecord?.error
                      ?.certificateOfCompletionPath
                  }
                />
              </div>
            )}
          {props.isCompleted && (
            <div className="mt-6">
              <label
                className="block text-sm font-medium text-gray-700 mb-1"
                htmlFor="FinalInvoiceFilePath"
              >
                Form A{" "}
                <span className="text-red-500">*</span>{" "}
                  (You may upload up to 10 files)
              </label>

              {/* Hidden File Input */}
              <input
                type="file"
                id="FinalInvoiceFilePath"
                multiple
                onChange={(event) =>
                  props.onFileChange(event, "FinalInvoiceFilePath")
                }
                className="hidden"
              />

              {/* Custom Orange Upload Button */}
              <label
                htmlFor="FinalInvoiceFilePath"
                className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
              >
                Upload Files
              </label>

              {/* Uploaded Files List */}
              {props.finalInvoiceFilePathList?.length > 0 && (
                <div className="mt-5 space-y-2">
                  {props.finalInvoiceFilePathList.map((file, index) => {
                    let fileName = "Unnamed File";

                    if (typeof file === "string") {
                      fileName = file.split("/").pop() || "Unnamed File";
                    } else if (typeof file?.name === "string") {
                      fileName = file.name;
                    } else if (typeof file?.path === "string") {
                      fileName = file.path.split("/").pop() || "Unnamed File";
                    }

                    return (
                      <div
                        key={index}
                        className="file-uploaded-txt flex items-center text-sm text-black"
                      >
                        <img
                          src="/check-orange.png"
                          className="w-[25px] mr-3"
                          alt=""
                        />
                        <span>{fileName}</span>

                        <button
                          className="underline text-[#e74c3c] font-[500] ml-3"
                          onClick={() =>
                            props.GetSlotsMemberFiles(
                              "FinalInvoiceFile",
                              fileName
                            )
                          }
                        >
                          Download File
                        </button>

                        <button
                          className="underline text-[#e74c3c] font-[500] ml-3"
                          onClick={() =>
                            props.deleteFile(fileName, "Upload_final_invoice_Completed")
                          }
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
          <ValidationText
            error={
              props.validStateProjectTrackRecord?.error
                ?.FinalInvoiceFilePathCompleted
            }
          />
          {props.isOngoing && (
            <div className="mt-6">
              <label
                className="block text-sm font-medium text-gray-700 mb-1"
                htmlFor="FinalInvoiceFilePath"
              >
                Form A
                <span className="text-red-500">*</span>{" "}
                  (You may upload up to 10 files)
              </label>

              {/* Hidden File Input */}
              <input
                type="file"
                id="FinalInvoiceFilePath"
                multiple
                onChange={(event) =>
                  props.onFileChange(event, "FinalInvoiceFilePath")
                }
                className="hidden"
              />

              {/* Custom Orange Upload Button */}
              <label
                htmlFor="FinalInvoiceFilePath"
                className="inline-block cursor-pointer bg-orange-500 text-white font-semibold py-2 px-4 rounded hover:bg-orange-600 transition"
              >
                Upload Files
              </label>

              {/* Uploaded Files List */}
              {props.finalInvoiceFilePathList?.length > 0 && (
                <div className="mt-5 space-y-2">
                  {props.finalInvoiceFilePathList.map((file, index) => {
                    let fileName = "Unnamed File";

                    if (typeof file === "string") {
                      fileName = file.split("/").pop() || "Unnamed File";
                    } else if (typeof file?.name === "string") {
                      fileName = file.name;
                    } else if (typeof file?.path === "string") {
                      fileName = file.path.split("/").pop() || "Unnamed File";
                    }

                    return (
                      <div
                        key={index}
                        className="file-uploaded-txt flex items-center text-sm text-black"
                      >
                        <img
                          src="/check-orange.png"
                          className="w-[25px] mr-3"
                          alt=""
                        />
                        <span>{fileName}</span>

                        <button
                          className="underline text-[#e74c3c] font-[500] ml-3"
                          onClick={() =>
                            props.GetSlotsMemberFiles(
                              "FinalInvoiceFile",
                              fileName
                            )
                          }
                        >
                          Download File
                        </button>

                        <button
                          className="underline text-[#e74c3c] font-[500] ml-3"
                          onClick={() =>
                            props.deleteFile(fileName, "Upload_final_invoice_Ongoing")
                          }
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
          <ValidationText
            error={
              props.validStateProjectTrackRecord?.error?.FinalInvoiceFilePath
            }
          />
          {/* Buttons */}
          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={props.closeModal}
              className="px-4 py-2 border rounded-md text-gray-600 hover:bg-gray-100"
            >
              Cancel
            </button>
            {props && props.isLoading ? (
              <ButtonLoader type="btn btn-orange" />
            ) : (
              <button
                type="button"
                onClick={() => {
                  const newProject = {
                    ongoingProjectID:
                      props.projectTrackRecordsDetails.ongoingProjectID,
                    completedProjectID:
                      props.projectTrackRecordsDetails.completedProjectID,
                    contractNo: props.projectTrackRecordsDetails.contractNo,
                    projectTitle: props.projectTrackRecordsDetails.projectTitle,
                    projectLocation:
                      props.projectTrackRecordsDetails.projectLocation,
                    projectTypeId: props.projectTrackRecordsDetails.projectType,
                    agency: props.projectTrackRecordsDetails.agency,
                    dateOfCommencement:
                      props.projectTrackRecordsDetails.dateOfCommencement,
                    dateofCompletion:
                      props.projectTrackRecordsDetails.dateofCompletion,
                    actualDateOfCompletion:
                      props.projectTrackRecordsDetails.actualDateOfCompletion,
                    awardValue: props.projectTrackRecordsDetails.awardValue,
                    mainContractorName:
                      props.projectTrackRecordsDetails.mainContractorName,
                    mainContractorTelephoneNo:
                      props.projectTrackRecordsDetails
                        .mainContractorTelephoneNo,
                    mainContractorEmail:
                      props.projectTrackRecordsDetails.mainContractorEmail,
                    contactPersonName:
                      props.projectTrackRecordsDetails.contactPersonName,
                    isOngoing: props.isOngoing,
                    isCompleted: props.isCompleted,
                    
                  };

                  props.handleSave(newProject);
                }}
                className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600"
              >
                {props.editModel ? "Save Changes" : "Save"}
              </button>
            )}
          </div>
        </div>
      </div>
    </ModalBasic>
  );
}

export default AddEditProject;
